module.exports = __webpack_public_path__ + "media/assets/community/badge-iab-contributor-27f9717f149fd1a94ae685e8a6e30ba20e1d52d8fdb288fc61697763848ad759.png";